import $ from 'jquery'

export default {
  bind (el) {
    $(el).on('show.bs.collapse', event => {
      $(event.target).parents('.panel').find('.stepper-number').addClass('stepper-active')
    }).on('hide.bs.collapse', event => {
      $(event.target).parents('.panel').find('.stepper-number').removeClass('stepper-active')
    })
  }
}



// WEBPACK FOOTER //
// ./src/directives/collapse-stepper.js